/**
 * Soft-refetch Offers/Contact (and related) queries after PWA/tab resume.
 * No full page reload — only active queries for the current store slug.
 */
import { restoreStoreSessionToLocalStorage } from './storeSession';

export function resumeStoreQueries(queryClient, slug) {
  if (!queryClient || !slug) return;

  restoreStoreSessionToLocalStorage(slug);

  const resumeRoots = new Set(['home', 'offers', 'branches', 'branchesCities', 'category']);

  queryClient.refetchQueries({
    type: 'active',
    predicate: (query) => {
      const key = query.queryKey;
      if (!Array.isArray(key) || !resumeRoots.has(key[0])) return false;
      if (key[0] === 'category' || key[0] === 'home') return key.includes(slug);
      return key.includes(slug);
    },
  });
}
